import * as React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

export const CustomToolTip = ({
  children,
  title,
  highlight,
}: {
  children?: any
  title: any
  highlight?: boolean
}) => {
  const GeenToolTip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'rgba(56, 70, 27, 0.95)',
      color: '#fff',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(16),
      boxShadow: theme.shadows[2],
      borderRadius: 10,
      padding: '22px 15px',
      fontFamily: 'Poppins, sans-serif',
    },
  }))

  return (
    <div
      style={{
        display: 'inline-block',
        cursor: 'pointer',
        backgroundColor: highlight ? '#95c11c' : 'transparent',
        fontWeight: highlight ? '600' : '400',
      }}
    >
      <GeenToolTip title={title} arrow>
        {children}
      </GeenToolTip>
    </div>
  )
}
